@if (showPage()) {
<div>
  <div [hidden]="state === UAState.VIEW_REPORT" class="ot-panel">
    <div class="ot-panel__header">
      @if (isSupportHotfix && isMasterSystemOnline && isQuickAnalysisRequired) {
      <div class="ot-message ot-message--is-error">
        <div class="ot-message__banner">
          <p class="ot-message__item" i18n>
            An analysis of the primary system must be completed before continuing.&nbsp;<a
              (click)="analyzeMasterSystemClicked()">Analyze primary system</a>
          </p>
        </div>
      </div>
      }
      @if (isSupportHotfix && isMasterSystemOnline && !isQuickAnalysisRequired && !isMasterSystemSelected) {
      <div class="ot-message ot-message--is-error">
        <div class="ot-message__banner">
          <p class="ot-message__item" i18n>
            A primary system must be selected. Please review the error below.
          </p>
        </div>
      </div>
      }
      @if (!isMasterSystemOnline) {
      <div class="ot-message ot-message--is-error">
        <div class="ot-message__banner">
          <p class="ot-message__item" i18n>
            The agent on the primary system is offline.
          </p>
        </div>
      </div>
      }
    </div>
    <div class="ua-no-errors" [ngClass]="{'ua-errors': isError()}">
      <ng-scrollbar #instanceScrollBarRef>
        <div class="ot-form-control ot-mb-0" style="flex-direction: unset;">
          <label class="ot-pl-1 ot-pr-1" style="padding-top: 10px" for="select-list" i18n>Target Update</label>
          <div class="ot-select" style="width:auto;">
            <select name="" id="select-list" aria-label="" (change)="this.availablePatchChange($event)"
              [disabled]="isAnalyzing || this.availablePatches.length == 0 || !isMasterSystemOnline">
              @for (patch of availablePatches; track patch; let i = $index) {
              <option [value]="patch.details.binaryuid" [selected]="patch.details.binaryuid == selectedUpdateBinaryUId">
                {{patch.name}}</option>
              }
            </select>
          </div>
          <div role="group" class="ot-btn-group ot-mb-0">
            <button role="button" i18n-title title="Anlayze" class="ot-btn ot-btn--is-primary"
              [disabled]="isAnalyzing || selectedInstanceRows.length == 0 || this.availablePatches.length == 0 || !isMasterSystemOnline || isQuickAnalysisRequired"
              (click)="analyze()" i18n>Analyze</button>
            <button role="button" i18n-title title="Back" class="ot-btn" [disabled]="isAnalyzing" (click)="back()"
              i18n>Back</button>
          </div>
        </div>
        <div class="ot-row">
          <p class="ot-pl-1 ot-pr-1" i18n>
            Content Server Update Analysis gives you insight into the changes that a Content Server Update will make to
            your system. By using Update Analysis, you can determine if any of the files in your Content Server
            deployment need to be preserved or removed before you apply a Content Server Update.
          </p>
        </div>
        <div class="ot-row" style="margin-bottom: 0px;">
          @if (isSupportHotfix && isMasterSystemOnline && !isQuickAnalysisRequired && isMasterSystemSelected &&
          isAnalyzing) {
          <div class="ot-message ot-message--is-progress w-100">
            <div class="ot-message__banner">
              <p class="ot-message__item" i18n>
                {uaReportNumInstances,
                plural,
                =1 { Analyzing an instance. Please wait...}
                other { Analyzing {{uaReportNumInstances}} instances. Please wait...}
                }
              </p>
            </div>
          </div>
          }
          @if (isSupportHotfix && isMasterSystemOnline && !isQuickAnalysisRequired && isMasterSystemSelected &&
          !isAnalyzing && isAnalyzed && uaReportNumInstancesError == 0) {
          <div class="ot-message ot-message--is-success w-100">
            <div class="ot-message__banner">
              <p class="ot-message__item" i18n>
                {uaReportNumInstances,
                plural,
                =1 { {{uaReportNumInstances}} instance was analyzed successfully.}
                other { {{uaReportNumInstances}} instances were analyzed successfully.}
                }
              </p>
            </div>
          </div>
          }
          @if (isSupportHotfix && isMasterSystemOnline && !isQuickAnalysisRequired && isMasterSystemSelected &&
          !isAnalyzing && isAnalyzed && uaReportNumInstancesError > 0) {
          <div class="ot-message ot-message--is-error w-100">
            <div class="ot-message__banner">
              <p class="ot-message__item" i18n>
                {{uaReportNumInstancesError}}/{{uaReportNumInstances}} instance(s) could not be analyzed. View&nbsp;<a
                  (click)="viewError()">details</a>
              </p>
            </div>
          </div>
          }
        </div>
        <app-tabs [identifier]="'product-ua-tabs'" [tabs]="tabs" [color]="TabColor.SECONDARY"></app-tabs>
        <app-datatable [identifier]="'product-ua-instance-table'" (selectAllClickEvent)="selectAllToAnalyze($event)"
          (onclickrowlink)="viewReport($event)" [isloading]="isLoading" (checkboxchangeevent)="selectToAnalyze($event)"
          [showcheckboxes]="true" [title]="''" [overrideShowError]="true" [cols]="componentTableCols"
          [rows]="componentTableRows" (actionmenuevent)="actionMenuClicked($event)" (rowclickevent)="rowClick($event)"
          [disableSelectAllCheckbox]="isAnalyzing" [scroll]="false"></app-datatable>
      </ng-scrollbar>
    </div>
  </div>
  <div [hidden]="state !== UAState.VIEW_REPORT" class="ot-panel">
    <div class="otsc-ua-report-container">
      <div class="otsc-ua-report-container_nav" style="border-right: 1px solid #d5d5d5;">
        <div>
          <button (click)="goBack()" aria-label="back" i18n-title title="Go back"
            class="otsc-btn__back ot-btn ot-btn--is-micro ot-btn--is-icon-btn">
            <div class="ot-icon ot-icon__action" id="otsc-ua-report__back_btn">
            </div>
          </button>
        </div>
        <div class="otsc-text__back" i18n>Instances</div>
      </div>
      <div class="otsc-ua-report-container_nav">
        <div class="otsc-ua-report-title" i18n>
          Update analysis delta report
        </div>
      </div>
      <div class="otsc-ua-report-container_content" style="border-right: 1px solid #d5d5d5;;padding-top: 8px;">
        <ul class="ot-list">
          @for (row of componentTableRows; track row) {
          <li (click)="switchReport(row)" tabindex="-1" class="ot-list__item" style="padding: 8px 21px;"
            [ngClass]="{'otsc-list__item_selected': row.data.viewReportSelected}">
            <span>{{row.data.system}} ({{row.data.installPath}})</span>
          </li>
          }
        </ul>
      </div>
      <div class="otsc-ua-report-container_content">
        @if (currentDeltaReport) {
        <div>
          <app-tabs [identifier]="'product-ua-report-tabs'" (selected)="onUAReportTabChange($event)"
            [tabs]="uaReportTabs" [color]="TabColor.PRIMARY" [selectedIndex]="uaReportActiveTab"></app-tabs>
          <div class="ua-report-content-area">
            <ng-scrollbar #scrollbarReportRef>
              <div class="ot-pl-3 ot-pr-3" style="padding-bottom: 50px;">
                <div id="otsc-ua-report-overview" class="otsc-ua-report-section">
                  <div class="otsc-ua-report-section-title" i18n>Overview</div>
                  <p class="ot-pb-0 otsc-ua-report-section-desc" i18n>
                    The purpose of this report is to inform you of what files will be changed when applying
                    <b>{{currentDeltaReport.targetUpdateDisplayName}}</b> and to which version each file belongs. It
                    will do a comparison based on <b>{{currentDeltaReport.currentUpdateDisplayName}}</b> files to the
                    ones found in your OTHome directory. If a file is found on your system, it will try to match the
                    file to a version in the manifest, and report on it accordingly. Files will be classified as
                    <b>NEW</b>, <b>VERIFIED</b> or <b>DIFFERENT</b>.
                  </p>
                </div>
                <div id="otsc-ua-report-summary" class="otsc-ua-report-section">
                  <div class="otsc-ua-report-section-title" i18n>Summary</div>
                  <div class="otsc-ua-report-section-text">
                    <div>
                      <b i18n>Current Content Server Deployment:</b>
                    </div>
                    <div class="ot-pl-1" i18n>
                      Update: {{currentDeltaReport.currentUpdateDisplayName}}
                    </div>
                    <div class="ot-pl-1" i18n>
                      Number of installed patches: {{currentDeltaReport.installedPatches.length}}
                    </div>
                    @if ((currentDeltaReport.deprecatedPatches && currentDeltaReport.deprecatedPatches.length > 0) ||
                    (currentDeltaReport.modifiedDeprecatedPatches && currentDeltaReport.modifiedDeprecatedPatches.length
                    > 0)) {
                    <div>
                      <div>
                        <b i18n>Deprecated Patches for {{currentDeltaReport.targetUpdateDisplayName}}</b>
                      </div>
                      @if ((currentDeltaReport.deprecatedPatches && currentDeltaReport.deprecatedPatches.length > 0)) {
                      <div class="ot-pl-1" i18n>
                        The following patch(es) can safely be removed:
                        <b>[{{currentDeltaReport.deprecatedPatches.join(', ')}}]</b>
                      </div>
                      }
                      @if ((currentDeltaReport.modifiedDeprecatedPatches &&
                      currentDeltaReport.modifiedDeprecatedPatches.length > 0)) {
                      <div class="ot-pl-1" i18n>
                        The following patch(es) are also deprecated, but some files associated with these patches are
                        categorized as DIFFERENT, and should be backed up since any modifications will be potentially
                        lost.: <b>[{{currentDeltaReport.modifiedDeprecatedPatches.join(',')}}]</b>
                      </div>
                      }
                    </div>
                    }
                    <div>
                      <b i18n>Files Included in {{currentDeltaReport.targetUpdateDisplayName}}:</b>
                    </div>
                    <div class="ot-pl-1" i18n>
                      Total number of checked files: {{currentDeltaReport.numScannedFiles}}
                    </div>
                    <div class="ot-pl-1" i18n>
                      Number of files categorized as <b>DIFFERENT</b>: {{currentDeltaReport.numDiffFiles}}
                    </div>
                    <div class="ot-pl-1" i18n>
                      Number of files categorized as <b>VERIFIED</b>: {{currentDeltaReport.numVerifiedFiles}}
                    </div>
                    <div class="ot-pl-1" i18n>
                      Number of files categorized as <b>NEW</b>: {{currentDeltaReport.numNewFiles}}
                    </div>
                  </div>
                </div>
                <div id="otsc-ua-report-howto" class="otsc-ua-report-section">
                  <div class="otsc-ua-report-section-title" i18n>How to Understand</div>
                  <div class="otsc-ua-report-section-text">
                    <div i18n>
                      File Type Legend:
                    </div>
                    <div class="ot-pl-1" i18n>
                      <b>DIFFERENT</b> - The file in your OTHome directory does not match a known version listed in the
                      manifest. It may have been customized by the System Administrator, 3rd party integration, or a
                      patch not listed in the manifest.
                    </div>
                    <div class="ot-pl-1" i18n>
                      <b>NEW</b> - The file listed in the manifest is new and/or does not exist in your OTHome
                      directory.
                    </div>
                    <div class="ot-pl-1" i18n>
                      <b>VERIFIED</b> - The file in your OTHome directory matches a known version in the manifest.
                    </div>
                    <div i18n>
                      Use the dropdown menus at the bottom of <b>Update/HotFix</b> and Type Columns to filter the
                      entries.
                    </div>
                    <div i18n>
                      Use the built in search functionality to quickly find the desired file(s).
                    </div>
                    <div i18n>
                      We strongly recommend copying <b>DIFFERENT</b> Type files to a temporary location before applying
                      the Content Server Update.
                    </div>
                    <div i18n>
                      There may be some files that are included across multiple updates that have not changed. This
                      report will match the first update that originally contained the file(s).
                    </div>
                    <div i18n>
                      If a file is categorized as <b>DIFFERENT</b> and shows a patch number in the Update/HotFix column
                      then it means that the file is associated with the installed patch but does not match the version
                      listed in the manifest.
                    </div>
                  </div>
                </div>
                <div id="otsc-ua-report-table" class="otsc-ua-report-section">
                  <div class="otsc-ua-report-section-title" i18n>Report</div>
                  <div class="otsc-ua-report-section-text report-table-container">
                    <app-datatable [identifier]="'product-ua-report-table'" (onclickcolumn)="sortUAFiles($event)"
                      [pagination]="true" (pageevent)="onPageChange($event)"
                      [total]="currentDeltaReport.updateReportDataFiles.length" [showcheckboxes]="false"
                      [cols]="uaTableCols" [rows]="uaTableRows"></app-datatable>
                  </div>
                </div>
              </div>
            </ng-scrollbar>
          </div>
        </div>
        } @else {
        <div class="otsc-no-items__icon"></div>
        <div class="otsc-no-items__text" i18n>
          There are no update analysis delta report to display for selected instance.
        </div>
        }
      </div>
    </div>
  </div>
</div>
} @else {
<div class="ot-progress ot-progress--is-bouncer ot-progress--is-bouncer-big ot-progress--is-bouncer-has-text">
  <div class="ot-progress__outer">
    <div class="ot-progress__meter"></div>
  </div>
  @if (isLoading && !isManifestUpdating && !isAgentManifestUpdating) {
  <div class="ot-progress__text" i18n>Loading...</div>
  }
  @if (isManifestUpdating) {
  <div class="ot-progress__text" i18n>Please wait while the manifest is updated...</div>
  }
  @if (isAgentManifestUpdating) {
  <div class="ot-progress__text" i18n>Please wait while the Agent manifest is updated...</div>
  }
</div>
}